// 3rd party
import * as React from 'react';
import { useCopyToClipboard } from 'react-use';

// UI Toolkit
import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkTextArea } from 'uitk-react-input';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkHeading } from 'uitk-react-text';

interface WidgetCodeMarkupFormProps {
  codeMarkup: string;
}

const WidgetCodeMarkupForm = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetCodeMarkupForm(props: WidgetCodeMarkupFormProps): JSX.Element {
    const { codeMarkup, ...otherProps } = props;

    const [isCopying, setIsCopying] = React.useState(false);
    const codeMarkupRef = React.useRef<HTMLTextAreaElement>();

    const [, copyToClipboard] = useCopyToClipboard();

    function handleCopyButtonClick() {
      setIsCopying(true);
      codeMarkupRef.current.focus();

      copyToClipboard(codeMarkup);

      setTimeout(() => {
        codeMarkupRef.current.blur();
        setIsCopying(false);
      }, 1500);
    }

    return (
      <form {...otherProps}>
        <UitkLayoutGrid space="two">
          <UitkLayoutGridItem>
            <div>
              <fieldset>
                <legend className="is-visually-hidden">
                  <UitkHeading tag="h3" size={6}>
                    {/*<LocalizedText message="product.widget.code.form.markup.title" />*/}
                    {'Markup'}
                  </UitkHeading>
                </legend>

                <UitkTextArea
                  domRef={codeMarkupRef}
                  // label={l10n.formatText('product.widget.code.form.markup.label')}
                  label={'Code Markup'}
                  value={codeMarkup}
                  hasVisibleLabel={false}
                />
              </fieldset>
            </div>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem>
            <div>
              <fieldset>
                <legend className="is-visually-hidden">
                  <UitkHeading tag="h3" size={6}>
                    {/*<LocalizedText message="product.widget.code.form.actions.title"/>*/}
                    {'Actions'}
                  </UitkHeading>
                </legend>

                <UitkLayoutFlex direction="row" space="two">
                  <UitkLayoutFlexItem>
                    <div>
                      <UitkSecondaryButton type="button" onClick={handleCopyButtonClick}>
                        {/*<LocalizedText message="product.widget.code.form.actions.copy_to_clipboard" />*/}
                        {/*{'Copy to Clipboard'}*/}
                        {/*/!*<LocalizedText message="product.widget.code.form.actions.copied_to_clipboard" />*!/*/}
                        {/*{'Copied to Clipboard'}*/}
                        {isCopying ? 'Copied to Clipboard' : 'Copy to Clipboard'}
                      </UitkSecondaryButton>
                    </div>
                  </UitkLayoutFlexItem>
                </UitkLayoutFlex>
              </fieldset>
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </form>
    );
  },
);

export { WidgetCodeMarkupForm };
